/*============================================================================
  Cart Drawer Upsell - Quick Add to Cart
  "Votre routine serait plus complète avec" - Ajout en 1 clic avec tracking
  + _trigger : attribution du vrai produit déclencheur (lu depuis data-trigger)
==============================================================================*/

(function() {
  'use strict';

  var selectors = {
    addButton: '.cart-upsell-card__add-btn'
  };

  var classes = {
    loading: 'is-loading',
    success: 'is-success'
  };

  function CartDrawerUpsell() {
    this.init();
  }

  CartDrawerUpsell.prototype = {

    init: function() {
      document.addEventListener('click', this.handleAddClick.bind(this));
      document.addEventListener('CartDrawer:open', this.addCloseButton.bind(this));

      /*============================================================================
        Guard Personal Shopper — ne pas ouvrir le drawer upsell si l'ATC
        vient du personal shopper (from_personal_shopper: true dans le detail)
      ==============================================================================*/
      document.addEventListener('ajaxProduct:added', function(e) {
        if (e.detail && e.detail.from_personal_shopper) {
          setTimeout(function() {
            var headerCart = document.getElementById('HeaderCart');
            if (headerCart && headerCart.classList.contains('is-active')) {
              headerCart.classList.remove('is-active');
            }
          }, 50);
          return;
        }
      });

      this.watchDrawerState();
      this.observeUpsellSection();
      this.observeReviewsSlider();
    },

    /*============================================================================
      watchDrawerState
      Observe .is-active sur #HeaderCart directement.
      À l'ouverture : déplacer vers body pour sortir du stacking context
      de .header-section (z-index:6 sticky).
      À la fermeture : remettre à sa place d'origine.
    ==============================================================================*/
    watchDrawerState: function() {
      if (window.innerWidth < 1024) return;
      var self = this;

      var headerCart = document.getElementById('HeaderCart');
      if (!headerCart) return;

      this._headerCartParent = headerCart.parentNode;
      this._headerCartNextSibling = headerCart.nextSibling;

      self._syncActiveState(headerCart);

      var observer = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].type === 'attributes' &&
              mutations[i].attributeName === 'class' &&
              mutations[i].target === headerCart) {
            self._syncActiveState(headerCart);
          }
        }
      });

      observer.observe(headerCart, { attributes: true });
      this._stateObserver = observer;
    },

    _syncActiveState: function(headerCart) {
      if (!headerCart) return;

      var isOpen = headerCart.classList.contains('is-active');

      if (isOpen && headerCart.parentNode !== document.body) {
        this._headerCartParent = headerCart.parentNode;
        this._headerCartNextSibling = headerCart.nextSibling;
        document.body.appendChild(headerCart);
        headerCart.style.top = '38px';
        this.addCloseButton();
      } else if (!isOpen && headerCart.parentNode === document.body) {
        headerCart.style.top = '';
        if (this._headerCartParent) {
          if (this._headerCartNextSibling) {
            this._headerCartParent.insertBefore(headerCart, this._headerCartNextSibling);
          } else {
            this._headerCartParent.appendChild(headerCart);
          }
        }
      }
    },

    /*============================================================================
      MutationObserver — [data-cart-upsell]
    ==============================================================================*/
    observeUpsellSection: function() {
      if (window.innerWidth < 1024) return;

      var self = this;

      var observer = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var mutation = mutations[i];
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];
            if (node.nodeType !== 1) continue;

            var upsellSection = null;
            if (node.hasAttribute && node.hasAttribute('data-cart-upsell')) {
              upsellSection = node;
            } else if (node.querySelector) {
              upsellSection = node.querySelector('[data-cart-upsell]');
            }

            if (upsellSection) {
              if (upsellSection.closest('.cart-upsell-panel')) continue;
              self.moveUpsellToPanel(upsellSection);
              self.addCloseButton();
            }
          }
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
      this._upsellObserver = observer;
    },

    /*============================================================================
      MutationObserver — [data-upsell-reviews]
      Guard : on n'initialise le slider que si le bloc reviews n'est pas déjà
      marqué comme initialisé (_reviewsInitialized). Le déplacement de
      #HeaderCart vers body déclenche le MutationObserver une deuxième fois —
      sans ce guard, initReviewsSlider serait appelé deux fois et deux items
      .is-active se retrouveraient visibles simultanément.
    ==============================================================================*/
    observeReviewsSlider: function() {
      if (window.innerWidth < 1024) return;

      var self = this;

      var existing = document.querySelector('[data-upsell-reviews]');
      if (existing && !existing._reviewsInitialized) {
        existing._reviewsInitialized = true;
        self.initReviewsSlider(existing);
      }

      var observer = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var mutation = mutations[i];
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];
            if (node.nodeType !== 1) continue;

            var reviewsBlock = null;
            if (node.hasAttribute && node.hasAttribute('data-upsell-reviews')) {
              reviewsBlock = node;
            } else if (node.querySelector) {
              reviewsBlock = node.querySelector('[data-upsell-reviews]');
            }

            // Guard : ne pas réinitialiser si déjà initialisé
            if (reviewsBlock && !reviewsBlock._reviewsInitialized) {
              reviewsBlock._reviewsInitialized = true;
              self.initReviewsSlider(reviewsBlock);
            }
          }
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
      this._reviewsObserver = observer;
    },

    /*============================================================================
      Reviews slider — rotation toutes les 7s
      Nettoie toutes les classes .is-active existantes avant de démarrer
      pour éviter tout doublon résiduel.
    ==============================================================================*/
    initReviewsSlider: function(reviewsBlock) {
      var track = reviewsBlock.querySelector('[data-reviews-track]');
      if (!track) return;

      if (this._reviewsTimer) {
        clearInterval(this._reviewsTimer);
        this._reviewsTimer = null;
      }

      var items = track.querySelectorAll('.cart-upsell-reviews__item');
      if (items.length === 0) return;

      // Nettoyer toutes les classes is-active existantes
      for (var i = 0; i < items.length; i++) {
        items[i].classList.remove('is-active');
      }

      var current = 0;
      items[current].classList.add('is-active');

      this._reviewsTimer = setInterval(function() {
        items[current].classList.remove('is-active');
        current = (current + 1) % items.length;
        items[current].classList.add('is-active');
      }, 7000);
    },

    /*============================================================================
      Colonne upsell desktop
    ==============================================================================*/
    moveUpsellToPanel: function(upsellSection) {
      if (window.innerWidth < 1024) return;

      var headerCart = document.getElementById('HeaderCart');
      if (!headerCart) return;
      if (!upsellSection) return;

      var panel = headerCart.querySelector('.cart-upsell-panel');
      if (!panel) {
        panel = document.createElement('div');
        panel.className = 'cart-upsell-panel';
        headerCart.insertBefore(panel, headerCart.firstChild);
      }

      var existing = panel.querySelector('[data-cart-upsell]');
      if (existing && existing !== upsellSection) existing.remove();

      panel.appendChild(upsellSection);
    },

    /*============================================================================
      Bouton fermeture — .js-close-header-cart (bouton natif Fetch)
    ==============================================================================*/
    addCloseButton: function() {
      if (window.innerWidth < 1024) return;

      var headerCart = document.getElementById('HeaderCart');
      if (!headerCart) return;
      if (headerCart.querySelector('.cart-upsell-close-btn')) return;

      var btn = document.createElement('button');
      btn.className = 'cart-upsell-close-btn';
      btn.setAttribute('type', 'button');
      btn.setAttribute('aria-label', 'Fermer le panier');
      btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L16 16M16 2L2 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

      btn.addEventListener('click', function() {
        // Fermeture NATIVE du thème : réinitialise aussi l'en-tête (« FERMER X »
        // -> icônes Search / Profil / Panier). Avant, on retirait seulement
        // is-active, ce qui laissait l'en-tête bloqué en mode drawer ouvert.
        var nativeClose = document.querySelector('.js-close-header-cart');
        if (nativeClose) {
          nativeClose.click();
        } else {
          var headerCart = document.getElementById('HeaderCart');
          if (headerCart) headerCart.classList.remove('is-active');
        }
      });

      headerCart.appendChild(btn);
    },

    handleAddClick: function(evt) {
      var btn = evt.target.closest(selectors.addButton);
      if (!btn) return;

      evt.preventDefault();
      evt.stopPropagation();

      if (btn.classList.contains(classes.loading)) return;

      var variantId = btn.dataset.variantId;
      var productTitle = btn.dataset.productTitle;
      var productPrice = btn.dataset.productPrice;

      if (!variantId) {
        console.error('Cart Upsell: Variant ID manquant');
        return;
      }

      this.addToCart(btn, variantId, productTitle, productPrice);
    },

    addToCart: function(btn, variantId, productTitle, productPrice) {
      btn.classList.add(classes.loading);

      var deviceType = window.innerWidth < 768 ? 'mobile' : 'desktop';
      var card = btn.closest('.cart-upsell-card');

      // Produit déclencheur : lu sur la section [data-cart-upsell] (data-trigger)
      var upsellRoot = btn.closest('[data-cart-upsell]');
      var trigger = upsellRoot && upsellRoot.dataset.trigger ? upsellRoot.dataset.trigger : '';

      var props = {
        '_source': 'cart_upsell',
        '_device': deviceType
      };
      if (trigger) props['_trigger'] = trigger;

      var formData = {
        items: [{
          id: variantId,
          quantity: 1,
          properties: props
        }]
      };

      var cartAddUrl = window.theme && window.theme.routes && window.theme.routes.cartAdd
        ? window.theme.routes.cartAdd
        : '/cart/add.js';

      fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === 422 || data.status === 'bad_request') {
          this.showError(btn, data.description || data.message);
        } else {
          this.markCartWithUpsell();
          this.showSuccess(btn, productTitle, card);
          this.trackUpsellAdd(variantId, productTitle, productPrice, data, deviceType);

          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { variant_id: variantId, product: data, from_upsell: true }
          }));
        }
      })
      .catch(error => {
        console.error('Cart Upsell: Erreur ajout panier', error);
        this.showError(btn, 'Une erreur est survenue');
      });
    },

    markCartWithUpsell: function() {
      var cartUpdateUrl = window.theme && window.theme.routes && window.theme.routes.cartChange
        ? window.theme.routes.cartChange.replace('/change.js', '/update.js')
        : '/cart/update.js';

      fetch(cartUpdateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ attributes: { 'contains_upsell': 'true' } })
      })
      .then(response => response.json())
      .then(() => console.log('Cart Upsell: Attribut "contains_upsell" ajouté'))
      .catch(error => console.error('Cart Upsell: Erreur attribut', error));
    },

    showSuccess: function(btn, productTitle, card) {
      btn.classList.remove(classes.loading);
      btn.classList.add(classes.success);
      console.log('Cart Upsell: Produit ajouté -', productTitle);

      setTimeout(function() {
        if (card) {
          card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
          card.style.opacity = '0';
          card.style.transform = 'translateX(8px)';
          setTimeout(function() { card.remove(); }, 300);
        }
      }, 600);
    },

    showError: function(btn, message) {
      btn.classList.remove(classes.loading);
      if (message) { alert(message); }
      console.error('Cart Upsell: Erreur -', message);
    },

    trackUpsellAdd: function(variantId, productTitle, productPrice, productData, deviceType) {
      var priceInEuros = productPrice ? parseFloat(productPrice) / 100 : 0;

      if (typeof gtag !== 'undefined') {
        gtag('event', 'add_to_cart', {
          currency: 'EUR',
          value: priceInEuros,
          items: [{ item_id: variantId, item_name: productTitle, item_category: 'Upsell', price: priceInEuros, quantity: 1 }]
        });
        gtag('event', 'upsell_add_to_cart', {
          variant_id: variantId, product_title: productTitle, value: priceInEuros, device_type: deviceType
        });
      }

      if (typeof ga !== 'undefined') {
        ga('send', 'event', 'Upsell', 'Add to Cart', productTitle, priceInEuros);
      }

      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
          event: 'upsell_add_to_cart',
          device_type: deviceType,
          ecommerce: {
            currencyCode: 'EUR',
            add: { products: [{ id: variantId, name: productTitle, price: priceInEuros, quantity: 1, dimension1: 'Upsell' }] }
          }
        });
      }
    }
  };

  function init() {
    if (document.readyState !== 'loading') {
      new CartDrawerUpsell();
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        new CartDrawerUpsell();
      });
    }
  }

  init();

})();

/*============================================================================
  CART REWARDS — paliers panier : échantillon offert (29 €) + livraison (100 €)
  Remplace la barre de l'app Yaco Progress Bar. Markup : header-cart-drawer.liquid
  (bloc CART REWARDS), styles : cart-drawer-upsell.css. Adapté de promo-vitaminec.js
  (4 états, multi-devise EUR/£, tracking, résilience au re-render du drawer).

  États data-state : progress (sous 29, pas d'échantillon) | choose (29 atteint,
  à choisir) | added (échantillon présent, seuil ok) | warning (échantillon
  présent, panier repassé sous 29). data-ship : progress | done (100 atteint).
  L'échantillon offert ne compte pas dans le calcul des seuils.

  EN PRODUCTION depuis le 07/07/2026 ; app Yaco désinstallée le 15/07/2026.
  Coupe-circuit : ?pers-rewards=0 désactive sur le navigateur courant.
  Promo No Blues (16/07 → 28/07/2026) : terminée, bloc retiré.

  + GWP CASQUETTE (04–06/08/2026) : Casquette You Glow offerte dès 80 € d'achat,
    France uniquement, à sélectionner. États data-gwp-state : off | progress
    (teaser) | choose | added. La gratuité est garantie côté serveur par le
    discount automatique « Casquette offerte dès 80 € » (BXGY, prérequis 80 €
    hors casquette) — sous le seuil, elle serait facturée 25 €, d'où le retrait
    automatique. La casquette reste achetable seule : une ligne casquette payée
    (prix > 0, sans propriété _gwp) n'est jamais touchée par ce module.

  + CODE MONSERUM (18–23/08/2026) : Sérum Vitamine C 15 ml offert dès 120 €
    d'achat avec le code, France uniquement. Champ code dans le drawer :
    l'application passe par POST /cart/update.js { discount } (API panier
    Shopify), puis le cadeau est ajouté automatiquement dès que le panier est
    éligible. États data-code-state : off | field | undermin | applied.

  + MARCHÉ US (28/07/2026, demande Clara) : pas d'échantillons pour les
    commandes en USD (marché en-us) — palier échantillon masqué, échantillon
    retiré du panier le cas échéant.
==============================================================================*/

(function () {
  'use strict';

  /* EN PRODUCTION depuis le 07/07/2026. Coupe-circuit conservé :
     ?pers-rewards=0 désactive le module sur le navigateur courant
     (mémorisé en localStorage), ?pers-rewards=1 le réactive. */
  try {
    var gate = location.search.match(/[?&]pers-rewards=(0|1)/);
    if (gate) localStorage.setItem('persRewards', gate[1]);
    if (localStorage.getItem('persRewards') === '0') return;
    document.documentElement.classList.add('pers-rewards-active');
  } catch (e) { document.documentElement.classList.add('pers-rewards-active'); }

  var SAMPLE_T = 2900; // 29 € / £29 en unités mineures
  /* Livraison offerte : seuil par devise, aligné sur les tarifs d'expédition
     Shopify réels (France/Monaco : dès 100 € ; zone UK : dès £85 via DPD). */
  function shipThreshold(cur) { return (cur === 'GBP') ? 8500 : 10000; }

  /* Porte de test par campagne : ?<param>=1 force l'activation avant la date,
     ?<param>=0 coupe (mémorisé en localStorage). */
  function readGate(param, key) {
    try {
      var m = location.search.match(new RegExp('[?&]' + param + '=(0|1)'));
      if (m) localStorage.setItem(key, m[1]);
      return localStorage.getItem(key);
    } catch (e) { return null; }
  }
  function windowOn(gateVal, start, end) {
    if (gateVal === '0') return false;
    if (gateVal === '1') return true;
    var now = Date.now();
    return now >= start && now < end;
  }

  /* GWP CASQUETTE — Casquette You Glow (25 €) offerte dès 80 € d'achat
     (hors casquette), du 04/08 au 06/08/2026 inclus, France uniquement
     (devise EUR + attribut panier « Customer country » posé par Orbe).
     Porte de test : ?pers-cap=1 / ?pers-cap=0. */
  var GWP_T = 8000;
  var GWP_START = new Date('2026-08-04T00:00:00+02:00').getTime();
  var GWP_END = new Date('2026-08-07T00:00:00+02:00').getTime();
  var _gwpGate = readGate('pers-cap', 'persCap');
  function gwpEnabled() { return windowOn(_gwpGate, GWP_START, GWP_END); }

  /* CODE MONSERUM — Sérum Vitamine C 15 ml (42 €) offert dès 120 € d'achat
     avec le code, du 18/08 au 23/08/2026 inclus, France uniquement.
     Le seuil client est volontairement conservateur : 120 € hors cadeau et
     hors échantillons — on n'ajoute jamais un cadeau que Shopify pourrait
     facturer. Porte de test : ?pers-code=1 / ?pers-code=0. */
  var CODE_NAME = 'MONSERUM';
  var CODE_T = 12000;
  var CODE_START = new Date('2026-08-18T00:00:00+02:00').getTime();
  var CODE_END = new Date('2026-08-24T00:00:00+02:00').getTime();
  var _codeGate = readGate('pers-code', 'persCode');
  function codeEnabled() { return windowOn(_codeGate, CODE_START, CODE_END); }

  var routes = (window.theme && window.theme.routes) || {};
  var addUrl = routes.cartAdd || '/cart/add.js';
  var changeUrl = routes.cartChange || '/cart/change.js';
  var updateUrl = routes.cartChange ? routes.cartChange.replace('/change.js', '/update.js') : '/cart/update.js';

  var _currency = 'EUR';
  var _sampleInCartId = null;
  var _sampleRemoving = false;
  var _gwpInCartKey = null;
  var _gwpRemoving = false;
  var _codeGiftKey = null;
  var _codeGiftRemoving = false;
  var _codeAutoAdding = false;
  var _codeApplying = false;

  function curConf(cur) {
    if (cur === 'GBP') return { symbol: '£', before: true, dec: '.' };
    return { symbol: '€', before: false, dec: ',' };
  }

  /* 29 € / £29 ; 12,50 € / £12.50 — espace insécable avant € */
  function fmtAmount(minor, conf) {
    var n = minor / 100;
    var s = (Math.round(n) === n) ? String(n) : n.toFixed(2).replace('.', conf.dec);
    return conf.before ? conf.symbol + s : s + ' ' + conf.symbol;
  }

  function getRoot() { return document.querySelector('[data-cart-rewards]'); }

  /* Écrit txt partout, avec garde anti-boucle (MutationObserver) */
  function setAll(root, sel, txt) {
    var els = root.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) {
      if (els[i].textContent !== txt) els[i].textContent = txt;
    }
  }

  function frCountry(cart) {
    var country = (cart.attributes && cart.attributes['Customer country']) || '';
    return country === '' || country === 'FR';
  }

  /* Badges de palier sur les cartes upsell (28/07/2026, validé Valentin) :
     signale les produits dont l'ajout suffit à débloquer le prochain
     avantage. Prix lu sur data-product-price (unités mineures) du bouton
     d'ajout ; cartes en rupture (pas de bouton) ignorées. Priorité : sérum
     MONSERUM (client déjà engagé par le code) > casquette > livraison. */
  function upsellBadge(price, ctx, en) {
    if (ctx.codeReady && ctx.codeRemaining > 0 && price >= ctx.codeRemaining) {
      return en ? 'Unlocks your free 15ml serum' : 'Débloque votre sérum 15 ml offert';
    }
    var gwpHit = ctx.gwpReady && ctx.gwpRemaining > 0 && price >= ctx.gwpRemaining;
    var shipHit = ctx.shipRemaining > 0 && price >= ctx.shipRemaining;
    if (gwpHit && shipHit) return en ? 'Unlocks shipping + free cap' : 'Débloque livraison + casquette';
    if (gwpHit) return en ? 'Unlocks the free cap' : 'Débloque la casquette offerte';
    if (shipHit) return en ? 'Unlocks free shipping' : 'Débloque la livraison offerte';
    return '';
  }

  /* Écritures gardées (MutationObserver sur #HeaderCart -> pas de boucle).
     ctx null = tout effacer (panier vide, marché US sans paliers).
     Règle d'affichage (itérée avec Valentin le 28/07) : le badge n'apparaît
     que s'il DISCRIMINE les cartes visibles. Près du palier, « ça débloque »
     est une info de panier, pas de carte : si toutes les cartes qualifient
     (ou aucune), marquer serait redondant ou trompeur -> aucun badge, la
     barre « Plus que X € » suffit. Si certaines qualifient et d'autres non,
     les qualifiantes sont marquées : l'implication « les autres ne
     débloquent rien » est alors vraie, c'est l'info utile. */
  function decorateUpsells(ctx) {
    var en = (document.documentElement.lang || 'fr').toLowerCase().indexOf('en') === 0;
    var cards = document.querySelectorAll('.cart-upsell-card');
    var entries = [];
    var priced = 0, labeled = 0;
    var i, card;
    for (i = 0; i < cards.length; i++) {
      card = cards[i];
      var btn = card.querySelector('.cart-upsell-card__add-btn');
      var price = btn ? parseInt(btn.getAttribute('data-product-price'), 10) : NaN;
      var label = '';
      if (ctx && !isNaN(price)) {
        priced++;
        label = upsellBadge(price, ctx, en);
        if (label) labeled++;
      }
      entries.push(label);
    }
    var discriminant = labeled > 0 && labeled < priced;
    for (i = 0; i < cards.length; i++) {
      card = cards[i];
      var badge = card.querySelector('.cart-upsell-card__badge');
      if (discriminant && entries[i]) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'cart-upsell-card__badge';
          var info = card.querySelector('.cart-upsell-card__info');
          if (info) info.appendChild(badge); else card.appendChild(badge);
        }
        if (badge.textContent !== entries[i]) badge.textContent = entries[i];
      } else if (badge) {
        badge.remove();
      }
    }
  }

  function update() {
    var root = getRoot();
    if (!root) return;

    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) {
          root.hidden = true;
          decorateUpsells(null);
          return;
        }

        _currency = cart.currency || 'EUR';
        var conf = curConf(_currency);
        var sampleIds = (root.getAttribute('data-sample-variants') || '').split(',');
        var gwpEl = root.querySelector('[data-cr-gwp]');
        var gwpVariant = gwpEl ? gwpEl.getAttribute('data-cr-gwp-variant') : null;
        var codeEl = root.querySelector('[data-cr-code]');
        var codeVariant = codeEl ? codeEl.getAttribute('data-cr-code-variant') : null;

        /* eligible : seuils échantillon + livraison (tout sauf échantillons et
           cadeaux). gwpEligible : seuil casquette — exclut EN PLUS les lignes
           casquette payées, comme le prérequis du discount BXGY (sinon on
           proposerait un cadeau que Shopify facturerait). codeEligible : seuil
           MONSERUM — exclut de même toute ligne du sérum 15 ml. */
        var eligible = 0, gwpEligible = 0, codeEligible = 0;
        _sampleInCartId = null;
        _gwpInCartKey = null;
        _codeGiftKey = null;
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          var vid = String(it.variant_id);
          var props = it.properties || {};
          if (sampleIds.indexOf(vid) !== -1) {
            _sampleInCartId = vid; // l'échantillon ne compte dans aucun seuil
          } else if (gwpVariant && vid === gwpVariant && (props._gwp === 'cap-you-glow' || it.final_line_price === 0)) {
            _gwpInCartKey = it.key; // la casquette offerte ne compte pas
          } else if (codeVariant && vid === codeVariant && (props._gwp === 'monserum' || it.final_line_price === 0)) {
            _codeGiftKey = it.key; // le sérum 15 ml offert ne compte pas
          } else {
            eligible += it.final_line_price;
            if (!(gwpVariant && vid === gwpVariant)) gwpEligible += it.final_line_price;
            if (!(codeVariant && vid === codeVariant)) codeEligible += it.final_line_price;
          }
        }

        /* Marché US (USD, 28/07/2026, demande Clara) : pas d'échantillons pour
           les États-Unis — et vérification faite le même jour, il n'y a AUCUNE
           livraison offerte en zone US (seul tarif : DHL Express ~46 $ même à
           210 $ de panier), la barre « Free shipping · $100 » y était une
           fausse promesse. Module entièrement masqué en USD, échantillon
           retiré du panier le cas échéant. */
        if (_currency === 'USD') {
          root.hidden = true;
          if (_sampleInCartId) removeSampleSilent();
          decorateUpsells(null);
          return;
        }

        root.hidden = false;

        var badgeGwpReady = false, badgeGwpRemaining = 0;
        var badgeCodeReady = false, badgeCodeRemaining = 0;

        var shipT = shipThreshold(_currency);
        setAll(root, '[data-cr-remaining-sample]', fmtAmount(Math.max(SAMPLE_T - eligible, 0), conf));
        setAll(root, '[data-cr-remaining-ship]', fmtAmount(Math.max(shipT - eligible, 0), conf));
        setAll(root, '[data-cr-threshold-sample]', fmtAmount(SAMPLE_T, conf));
        setAll(root, '[data-cr-threshold-ship]', fmtAmount(shipT, conf));

        var fill = root.querySelector('[data-cr-fill]');
        if (fill) {
          var pct = Math.min(eligible / shipT * 100, 100) + '%';
          if (fill.style.width !== pct) fill.style.width = pct;
        }

        /* Repère échantillon : 29 % de l'échelle en EUR (29/100), 34 % en GBP (29/85) */
        var dot = root.querySelector('.cart-rewards__bar-dot--sample');
        if (dot) {
          var dotLeft = Math.round(SAMPLE_T / shipT * 100) + '%';
          if (dot.style.left !== dotLeft) dot.style.left = dotLeft;
        }

        var state;
        if (_sampleInCartId) state = (eligible >= SAMPLE_T) ? 'added' : 'warning';
        else state = (eligible >= SAMPLE_T) ? 'choose' : 'progress';
        if (root.getAttribute('data-state') !== state) root.setAttribute('data-state', state);

        var ship = (eligible >= shipT) ? 'done' : 'progress';
        if (root.getAttribute('data-ship') !== ship) root.setAttribute('data-ship', ship);

        /* GWP CASQUETTE : retrait automatique si le cadeau est au panier sans
           y avoir droit (sous 80 € hors casquette, hors fenêtre, hors France) —
           sans le discount il serait facturé 25 €. Ne touche jamais une
           casquette payée (détection par propriété _gwp / prix à 0). */
        if (gwpEl) {
          var gwpOn = gwpEnabled() &&
            gwpEl.getAttribute('data-cr-gwp-available') === '1' &&
            _currency === 'EUR' && frCountry(cart);
          var gwpActive = gwpOn ? '1' : '0';
          if (root.getAttribute('data-gwp-active') !== gwpActive) root.setAttribute('data-gwp-active', gwpActive);
          badgeGwpReady = gwpOn && !_gwpInCartKey;
          badgeGwpRemaining = Math.max(GWP_T - gwpEligible, 0);
          setAll(root, '[data-cr-remaining-gwp]', fmtAmount(Math.max(GWP_T - gwpEligible, 0), conf));
          var gwpState;
          if (!gwpOn) {
            gwpState = 'off';
            if (_gwpInCartKey) removeGwp();
          } else if (_gwpInCartKey) {
            gwpState = (gwpEligible >= GWP_T) ? 'added' : 'progress';
            if (gwpEligible < GWP_T) removeGwp();
          } else {
            gwpState = (gwpEligible >= GWP_T) ? 'choose' : 'progress';
          }
          if (gwpEl.getAttribute('data-gwp-state') !== gwpState) gwpEl.setAttribute('data-gwp-state', gwpState);
        }

        /* CODE MONSERUM : le code est porté par le panier côté serveur
           (cart.discount_codes). Une fois saisi, le cadeau s'ajoute tout seul
           dès 120 € hors cadeau, et se retire si le panier redescend (sans le
           discount il serait facturé 42 €). Un sérum 15 ml payé (prix > 0,
           sans propriété _gwp) n'est jamais touché. */
        if (codeEl) {
          var codeOn = codeEnabled() && _currency === 'EUR' && frCountry(cart);
          var codeApplied = false;
          var codes = cart.discount_codes || [];
          for (var c = 0; c < codes.length; c++) {
            if (String(codes[c].code || '').toUpperCase() === CODE_NAME) codeApplied = true;
          }
          setAll(root, '[data-cr-remaining-code]', fmtAmount(Math.max(CODE_T - codeEligible, 0), conf));
          badgeCodeReady = codeOn && codeApplied && !_codeGiftKey;
          badgeCodeRemaining = Math.max(CODE_T - codeEligible, 0);
          var codeState;
          if (!codeOn) {
            codeState = 'off';
            if (_codeGiftKey) removeCodeGift();
          } else if (_codeGiftKey) {
            /* Cadeau présent : on ne le retire que si le panier hors cadeau
               repasse sous le seuil (le discount ne le couvrirait plus). */
            codeState = 'applied';
            if (codeEligible < CODE_T) removeCodeGift();
          } else if (codeApplied) {
            if (codeEligible >= CODE_T && codeEl.getAttribute('data-cr-code-available') === '1') {
              codeState = 'undermin'; /* transitoire, le temps de l'ajout */
              autoAddCodeGift(codeEl);
            } else {
              codeState = 'undermin';
            }
          } else {
            codeState = 'field';
          }
          if (codeEl.getAttribute('data-code-state') !== codeState) codeEl.setAttribute('data-code-state', codeState);
        }

        decorateUpsells({
          shipRemaining: Math.max(shipT - eligible, 0),
          gwpReady: badgeGwpReady,
          gwpRemaining: badgeGwpRemaining,
          codeReady: badgeCodeReady,
          codeRemaining: badgeCodeRemaining
        });
      })
      .catch(function () { /* silencieux */ });
  }

  function addSample(btn) {
    if (btn.classList.contains('is-loading')) return;
    if (_sampleInCartId) return; // un seul échantillon
    btn.classList.add('is-loading');

    var variantId = btn.getAttribute('data-cr-add');

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1, properties: {
          '_source': 'cart_rewards'
        } }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        btn.classList.remove('is-loading');
        if (!data || data.status === 422 || data.status === 'bad_request') return;
        if (!data.items || data.items.length === 0) return; // ajout refusé silencieusement
        trackEvent('cart_rewards_sample_add', variantId);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { variant_id: variantId, product: data, from_upsell: true }
        }));
        setTimeout(update, 300);
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  }

  function removeSample(btn) {
    if (btn.classList.contains('is-loading')) return;
    if (!_sampleInCartId) return;
    btn.classList.add('is-loading');

    fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: _sampleInCartId, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        btn.classList.remove('is-loading');
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { from_upsell: true, product: cart }
        }));
        setTimeout(update, 300);
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  }

  /* Marché US : retrait silencieux de l'échantillon (ligne à 0 €) */
  function removeSampleSilent() {
    if (_sampleRemoving || !_sampleInCartId) return;
    _sampleRemoving = true;
    fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: _sampleInCartId, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        _sampleRemoving = false;
        _sampleInCartId = null;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { from_upsell: true, product: cart }
        }));
        setTimeout(update, 300);
      })
      .catch(function () { _sampleRemoving = false; });
  }

  function addGwp(btn) {
    if (btn.classList.contains('is-loading')) return;
    if (_gwpInCartKey) return; // un seul cadeau par commande
    btn.classList.add('is-loading');

    var variantId = btn.getAttribute('data-cr-gwp-add');

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1, properties: {
          '_source': 'cart_rewards',
          '_gwp': 'cap-you-glow'
        } }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        btn.classList.remove('is-loading');
        if (!data || data.status === 422 || data.status === 'bad_request' || !data.items || data.items.length === 0) {
          /* rupture de stock (policy deny) : on masque l'offre */
          var root = getRoot();
          var el = root && root.querySelector('[data-cr-gwp]');
          if (el) el.setAttribute('data-cr-gwp-available', '0');
          update();
          return;
        }
        trackEvent('cart_rewards_gwp_add', variantId);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { variant_id: variantId, product: data, from_upsell: true }
        }));
        setTimeout(update, 300);
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  }

  function removeGwp() {
    if (_gwpRemoving || !_gwpInCartKey) return;
    _gwpRemoving = true;
    fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: _gwpInCartKey, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        _gwpRemoving = false;
        _gwpInCartKey = null;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { from_upsell: true, product: cart }
        }));
        setTimeout(update, 300);
      })
      .catch(function () { _gwpRemoving = false; });
  }

  /* Saisie du code dans le drawer : application côté serveur par l'API panier
     (POST /cart/update.js { discount }) — le code suit ensuite le panier
     jusqu'au checkout. MONSERUM est géré par la machine à états d'update() ;
     tout autre code valide est simplement appliqué. */
  function applyCode(btn) {
    if (_codeApplying) return;
    var root = getRoot();
    var codeEl = root && root.querySelector('[data-cr-code]');
    var input = codeEl && codeEl.querySelector('[data-cr-code-input]');
    if (!input) return;
    var code = (input.value || '').trim().toUpperCase();
    if (!code) return;
    _codeApplying = true;
    if (btn) btn.classList.add('is-loading');

    fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ discount: code })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        _codeApplying = false;
        if (btn) btn.classList.remove('is-loading');
        var entry = null;
        var codes = (cart && cart.discount_codes) || [];
        for (var i = 0; i < codes.length; i++) {
          if (String(codes[i].code || '').toUpperCase() === code) entry = codes[i];
        }
        var fb = codeEl.querySelector('[data-cr-code-feedback]');
        if (code === CODE_NAME) {
          /* la machine à états prend le relais (ajout auto ou message seuil) */
          if (fb) fb.textContent = '';
          trackEvent('cart_rewards_code_apply', code);
          update();
        } else if (entry && entry.applicable) {
          if (fb) fb.textContent = codeEl.getAttribute('data-msg-applied') || '';
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { from_upsell: true, product: cart }
          }));
          update();
        } else {
          if (fb) fb.textContent = codeEl.getAttribute('data-msg-invalid') || '';
        }
      })
      .catch(function () {
        _codeApplying = false;
        if (btn) btn.classList.remove('is-loading');
      });
  }

  function autoAddCodeGift(codeEl) {
    if (_codeAutoAdding || _codeGiftKey) return;
    _codeAutoAdding = true;
    var variantId = codeEl.getAttribute('data-cr-code-variant');

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1, properties: {
          '_source': 'cart_rewards',
          '_gwp': 'monserum'
        } }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        _codeAutoAdding = false;
        if (!data || data.status === 422 || data.status === 'bad_request' || !data.items || data.items.length === 0) {
          /* rupture de stock : on fige le champ en l'état, sans réessayer */
          codeEl.setAttribute('data-cr-code-available', '0');
          update();
          return;
        }
        trackEvent('cart_rewards_code_gift_add', variantId);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { variant_id: variantId, product: data, from_upsell: true }
        }));
        setTimeout(update, 300);
      })
      .catch(function () { _codeAutoAdding = false; });
  }

  function removeCodeGift() {
    if (_codeGiftRemoving || !_codeGiftKey) return;
    _codeGiftRemoving = true;
    fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: _codeGiftKey, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        _codeGiftRemoving = false;
        _codeGiftKey = null;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { from_upsell: true, product: cart }
        }));
        setTimeout(update, 300);
      })
      .catch(function () { _codeGiftRemoving = false; });
  }

  /* Tracking best-effort (cadeaux à 0 € : la valeur est dans l'événement dédié) */
  function trackEvent(name, value) {
    try {
      if (typeof gtag !== 'undefined') {
        gtag('event', name, { variant_id: String(value), currency: _currency });
      }
      if (window.dataLayer) {
        window.dataLayer.push({ event: name, variant_id: String(value), currencyCode: _currency });
      }
    } catch (e) { /* silencieux */ }
  }

  /* Délégation : les boutons sont re-rendus avec le drawer */
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-cr-add]');
    if (addBtn) { e.preventDefault(); e.stopPropagation(); addSample(addBtn); return; }
    var removeBtn = e.target.closest('[data-cr-remove]');
    if (removeBtn) { e.preventDefault(); e.stopPropagation(); removeSample(removeBtn); return; }
    var gwpBtn = e.target.closest('[data-cr-gwp-add]');
    if (gwpBtn) { e.preventDefault(); e.stopPropagation(); addGwp(gwpBtn); return; }
    var codeBtn = e.target.closest('[data-cr-code-apply]');
    if (codeBtn) { e.preventDefault(); e.stopPropagation(); applyCode(codeBtn); return; }
  });

  /* Entrée dans le champ code : appliquer, sans soumettre le formulaire panier
     qui enveloppe tout le drawer (le champ n'a pas de <form> propre). */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('[data-cr-code-input]');
    if (!input) return;
    e.preventDefault();
    e.stopPropagation();
    var codeEl = input.closest('[data-cr-code]');
    var btn = codeEl && codeEl.querySelector('[data-cr-code-apply]');
    applyCode(btn);
  });

  document.addEventListener('ajaxProduct:added', function () { setTimeout(update, 300); });
  document.addEventListener('CartDrawer:open', function () { update(); });

  /* Le thème remplace le contenu du drawer à chaque changement panier :
     réévaluation débouncée à la moindre mutation. Écritures gardées -> pas de boucle. */
  var hc = document.getElementById('HeaderCart');
  if (hc) {
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(update, 150);
    }).observe(hc, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') update();
  else document.addEventListener('DOMContentLoaded', update);
})();

/*============================================================================
  Filet de sécurité lazyload (23/07) — images produit invisibles sur iOS.
  Le thème ne révèle une image (.lazyload, opacity 0) qu'après sa bascule en
  .lazyloaded par un IntersectionObserver posé sur <image-element>, or ce
  custom element mesure 0×0 (inline, aucun CSS ne lui donne de boîte) :
  Safari iOS ne le considère jamais comme intersectant et la bascule n'a
  jamais lieu (Chrome, lui, traite les cibles 0×0 comme intersectantes).
  On observe donc les <img> elles-mêmes (vraie boîte), même marge que le
  thème, et on fait la même bascule de classes.
==============================================================================*/
(function () {
  function reveal(img) {
    img.classList.remove('lazyload');
    img.classList.add('lazyloaded');
  }

  if (!('IntersectionObserver' in window)) {
    var flipAll = function () {
      document.querySelectorAll('img.lazyload').forEach(reveal);
    };
    if (document.readyState !== 'loading') flipAll();
    else document.addEventListener('DOMContentLoaded', flipAll);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        reveal(entry.target);
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px 400px 0px' });

  function scan() {
    document.querySelectorAll('img.lazyload').forEach(function (img) {
      io.observe(img); /* ré-observer une cible déjà suivie est un no-op */
    });
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);

  /* Contenu injecté après coup (drawer reconstruit, sections dynamiques) */
  var scanT;
  new MutationObserver(function () {
    clearTimeout(scanT);
    scanT = setTimeout(scan, 200);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
